import {
  GET_ASSURED_GIFTS_DATA,
  GET_ASSURED_GIFTS_DATA_SUCCESS,
  GET_ASSURED_GIFTS_DATA_ERROR
} from '../constants/assuredGiftsConstants';

const initialState = {
  data: {}
};

export default function assuredGiftsReducer(state = initialState, action) {
  const { type = '', data = {} } = action || {};
  switch (type) {
    case GET_ASSURED_GIFTS_DATA:
      return { ...state, data: { ...data } };
    case GET_ASSURED_GIFTS_DATA_SUCCESS:
      return { ...state, data };
    case GET_ASSURED_GIFTS_DATA_ERROR:
      return { ...state, data: { ...data } };
    default:
      return state;
  }
}
